import React from 'react'
import {get} from "../tools/restful"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import {Button} from 'reactstrap'
import MenuIdPage from './MenuIdPage'
import UntappdDataLayer from './UntappdDataLayer'
import TapsHorizontal from './MenuBoards/TapsHorizontal'
import TapsCansHorizontal from './MenuBoards/TapsCansHorizontal'
import SlicesHorizontal from './MenuBoards/SlicesHorizontal';
import TapsCans from './MenuPages/TapsCans'
import Wine from "./MenuPages/Wine"
import CocktailsHappyHour from "./MenuPages/CocktailsHappyHour"
import Desserts from "./MenuPages/Desserts"
import THC from "./MenuPages/THC"
import HappyHourTaps from "./page_updates/HappyHourTaps"
import CansCocktails from './page_updates/CansCocktails';
import CansMocktails from './page_updates/CansMocktails';
import THCSeltzerRed from './page_updates/THCSeltzerRed';

class ApiLayer extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            menus: []
        }
    }
    componentDidMount(){
        Promise.all([get('menu')])
        .then(([menus]) => this.setState(
            { menus: menus}
        ))
        .catch(err => err)
    }
    updateData = (model, id, action) => {

    }
    render(){
        console.log(this.state)
        return (
            <>
               
            <Switch>
                
                <Route 
                    exact path="/untappd/:tapsId/:bottlesId/:wineId"
                    render={(routeProps) => (
                        <UntappdDataLayer {...routeProps}/>
                    )}
                />
                <Route 
                    exact path="/menuboard/taps/horizontal/:tapsId/:color/:location"
                    render={(routeProps) => (
                        <TapsHorizontal {...routeProps} />
                    )}
                />
                <Route 
                    exact path="/menuboard/taps-cans/horizontal/:tapsId/:cansId/:color/:location"
                    render={(routeProps) => (
                        <TapsCansHorizontal {...routeProps} />
                    )}
                />
                 <Route 
                    exact path="/menupages/desserts/:color/:location"
                    render={(routeProps) => (
                        <Desserts {...routeProps} />
                    )}
                />
                <Route 
                     exact path="/menuboard/taps-cans/horizontal/:tapsId/:cansId/:color/:location/:layout"
                     render={(routeProps) => (
                         <TapsCansHorizontal {...routeProps} />
                     )}
                />
                <Route 
                    exact path="/menuboard/slices/horizontal/:sliceId/:color/:location"
                    render={(routeProps) => (
                        <SlicesHorizontal {...routeProps} />
                    )}
                />
                 <Route 
                    exact path="/menupages/taps-cans/:tapsId/:cansId/:color/:location"
                    render={(routeProps) => (
                        <TapsCans {...routeProps} />
                    )}
                />
                <Route 
                    exact path="/menupages/taps-hh/:tapsId/:color/:location"
                    render={(routeProps) => (
                        <HappyHourTaps {...routeProps} />
                    )}
                />
                <Route 
                    exact path="/menupages/cans-cocktails/:cansId/:cocktailsId/:color/:location"
                    render={(routeProps) => (
                        <CansCocktails {...routeProps} />
                    )}
                />

                <Route 
                    exact path="/menupages/cans-mocktails/:cansId/:mocktailsId/:color/:location"
                    render={(routeProps) => (
                        <CansMocktails {...routeProps} />
                    )}
                />

                <Route 
                    exact path="/menupages/seltzers-reds/:seltzerId/:wineId/:color/:location"
                    render={(routeProps) => (
                        <THCSeltzerRed {...routeProps} />
                    )}
                />

<Route 
                    exact path="/menupages/thcseltzers-reds/:seltzerId/:wineId/:color/:location"
                    render={(routeProps) => (
                        <THCSeltzerRed {...routeProps} />
                    )}
                />

                <Route 
                    exact path="/menupages/wine/:wineMenuId/:color/:location"
                    render={(routeProps) => (
                        <Wine {...routeProps} />
                    )}
                />
                <Route 
                    exact path="/menupages/cocktails-happyhour/:menuId/:color/:location"
                    render={(routeProps) => (
                        <CocktailsHappyHour {...routeProps} />
                    )}
                />
               
                <Route 
                    exact path="/menupages/thc/:location"
                    render={(routeProps) => (
                        <THC {...routeProps}/>
                    )}
                />
                
            </Switch>
            </>
        )
    }
}

export default ApiLayer